var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquareHalfBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Phosphor Icons / SquareHalfBottom"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_5159_9514",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 34,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 32,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 30H0V34H32V30Z",
    fill: "#1B90FE",
    mask: "url(#path-1-outside-1_5159_9514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6.5C4.5 5.39543 5.39543 4.5 6.5 4.5H25.5C26.6046 4.5 27.5 5.39543 27.5 6.5V25.5C27.5 26.6046 26.6046 27.5 25.5 27.5H6.5C5.39543 27.5 4.5 26.6046 4.5 25.5V6.5ZM25.5 6.5H6.5V25.5H25.5V6.5Z",
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10C4.5 9.44772 4.94772 9 5.5 9H26.5C27.0523 9 27.5 9.44772 27.5 10C27.5 10.5523 27.0523 11 26.5 11H5.5C4.94772 11 4.5 10.5523 4.5 10Z",
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10C10.5523 10 11 10.6089 11 11.36V25.64C11 26.3911 10.5523 27 10 27C9.44772 27 9 26.3911 9 25.64V11.36C9 10.6089 9.44772 10 10 10Z",
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10C14.5523 10 15 10.6089 15 11.36V25.64C15 26.3911 14.5523 27 14 27C13.4477 27 13 26.3911 13 25.64V11.36C13 10.6089 13.4477 10 14 10Z",
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18.5523 10 19 10.6089 19 11.36V25.64C19 26.3911 18.5523 27 18 27C17.4477 27 17 26.3911 17 25.64V11.36C17 10.6089 17.4477 10 18 10Z",
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10C22.5523 10 23 10.6089 23 11.36V25.64C23 26.3911 22.5523 27 22 27C21.4477 27 21 26.3911 21 25.64V11.36C21 10.6089 21.4477 10 22 10Z",
    fill: "#1B90FE"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareHalfBottom);
export default __webpack_public_path__ + "static/media/SquareHalfBottom.9c57e0c5a7936e361385b94a88cd98c1.svg";
export { ForwardRef as ReactComponent };